import React, { useRef, useState, useEffect, useImperativeHandle } from 'react'
import PropTypes from 'prop-types'
import Trash from './trash'
import { validateInput } from '../../utilities/Validator'
import '../../css/common.css'
import ConfirmationModal from './ConfirmationModal/ConfirmationModal'
import CustomModal from '../Modal/modal.js'
import { createAlert } from '../../../features/alert/alerts'
import { ALERT_TYPE_INFO } from '../../../constants/constants'
import { useDispatch } from "react-redux";

const UploadFile = ({
  onChange,
  label,
  inputClass,
  localLang,
  required,
  labelClass,
  name,
  onClick,
  validators,
  getError,
  accept,
  size,
  fileHandler,
  Error,
  resetFile,
  id,
  disabled,
  validTypes,
  reference
}) => {
  const ref = useRef()
  const [remove, setRemove] = useState(false)
  const [error, setError] = useState(false)
  const [showConfirmationPopup, setConfirmationPopup] = useState(false)
  const dispatch = useDispatch();

  useEffect(() => {
    if (getError) {
      getError(error.message)
    }
  }, [error])

  const onClose = () => {
    setConfirmationPopup(false)
  }
  const onInfo = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_INFO,
        heading: "INFO",
      })
    );
  };


  useImperativeHandle(reference, () => ({
    removeFile() {
      reset()
    },
  }))

  const handleChange = (event) => {
    let errorMessage = { ...error }
    if (event.target.files.length) {
      let file = event.target.files[0]
      let fileSize = file.size
      let type = file.type
      let ext = file.name.match(/\.([0-9a-z]+)(?:[\?#]|$)/i)
      if (file.name.split('.').length > 2) {
        event.target.value = null;   
        onInfo('Please select a file with a single extension.');
        return null
        }
      if (
        validTypes.indexOf(ext[0]?.toLowerCase()) === -1 &&
        accept.split(',').indexOf(type) === -1
      ) {
        errorMessage = {
          message: localLang
            ? localLang['FILE_TYPE']
            : 'Please select valid file type',
        }
        setError({
          message: localLang
            ? localLang['FILE_TYPE']
            : 'Please select valid file type',
        })
      } else {
        if (Math.round(fileSize / 1024) > size) {
          setError({
            message: localLang
              ? `${localLang['SIZE_LIMIT']} ${Math.round(size / 1024)} MB`
              : `Size limit exceeds ${Math.round(size / 1024)} MB`,
          })
          errorMessage = {
            message: localLang ? localLang['SIZE_LIMIT'] : 'Size limit exceeds',
          }
        } else {
          setError('')

          errorMessage = ''
        }
      }
    }
    onChange(event)
    setRemove(true)
    getError && getError(errorMessage ? errorMessage : false)
  }
  const reset = (event) => {
    ref.current.value = ''
    // setError({
    //   message: localLang ? localLang['ATTACH_FILE'] : 'Please attach a file',
    // })
    setRemove(false)
    setConfirmationPopup(false)
    resetFile && resetFile()
  }
  return (
    <>
      {showConfirmationPopup && (
        <CustomModal
          className="confirmation_modal"
          show={showConfirmationPopup}
          onClose={onClose}
          size="500px"
          closeIcon={false}
          modalTitle={
            localLang
              ? localLang['DELETE_TEXT']
              : 'Are you sure you want to delete this?'
          }
          children={
            <ConfirmationModal
              // title="You want to delete this"
              localLang={localLang}
              noOption={onClose}
              yesOption={reset}
            />
          }
        />
      )}
      {label && (
        <div className={labelClass}>
          <label htmlFor="" className="upload-label">
            {label} {required && <b className="text-danger">*</b>}
          </label>
        </div>
      )}
      <div className={inputClass}>
        <div className="inputImageWrapper">
          <input
            type="file"
            name={name}
            onChange={handleChange}
            className={`form-control library-file-upload ${
              remove ? 'fileClass' : ''
            } `}
            accept={accept}
            onInput={fileHandler}
            id={id}
            ref={ref}
            disabled={disabled}
          />
          {remove && (
            // <span className="removeImage" onClick={reset}>
            <span
              className="removeImage"
              onClick={() => setConfirmationPopup(true)}
            >
              <Trash
                width="12.739"
                height="14.559"
                fill="#555b6d"
                id="Icon_awesome-trash"
              />
            </span>
          )}
        </div>
        {(error || (Error && Error[name])) && (
          <span className="text-danger errormsg mt-1">
            {error.message || Error[name]}
          </span>
        )}
      </div>
    </>
  )
}

UploadFile.prototype = {
  value: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  validators: PropTypes.array,
  type: PropTypes.string,
  onchange: PropTypes.func.isRequired,
  labelClass: PropTypes.string,
  inputClass: PropTypes.string,
}

UploadFile.defaultProps = {
  label: '',
  placeholder: '',
  type: 'file',
  labelClass: 'col-md-4',
  inputClass: 'col-md-6',
}
export default UploadFile
